/* 
use:
    • pass an array in props name as routesArr = [{children: _a component to render in router_ , path: _route path_ , type: private || public || auth }] 

*/
import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { get } from "../services/localStorage";
import { LOGIN, LOG_OUT } from "../constant";
import { isClientUser, isDealerUser, redirectAfterLogin } from "../utils/userTypes";
// Default constants
export const DEFAULT_ROUTE = "/";
export const DEFAULT_AUTH_ROUTE = "/login";
export const localStorage_auth = () => {
  const localStorage_auth_data = get({ key: "auth" });
  return localStorage_auth_data
    ? localStorage_auth_data.token
      ? localStorage_auth_data
      : {}
    : {};
};
export let USER = localStorage_auth().token;

// Redux starts empty on a hard refresh and is filled from localStorage in an
// effect, so a stored token means "still restoring", not "logged out".
function isRestoringSession() {
  return Boolean(localStorage_auth().token);
}

function redirectTarget(from, fallback, auth) {
  if (auth) return redirectAfterLogin(auth, from);
  if (!from?.pathname) return { pathname: fallback };
  return {
    pathname: from.pathname,
    search: from.search || "",
    hash: from.hash || "",
  };
}
// 
// // =============== default router function
// function Index({ children, auth, login, logOut }) {

//   return <Switch>{children}</Switch>;
// }
// const mapStateToProps = (state) => ({
//   auth: state.auth,
// });
// const mapDispatchToProps = (dispatch) => ({
//   login: (data) =>
//     dispatch({
//       type: `${LOGIN}_SUCCESS`,
//       payload: { ...data },
//     }),
//   logOut: (data) =>
//     dispatch({
//       type: LOG_OUT,
//     }),
// });

// export default connect(mapStateToProps, mapDispatchToProps)(Index);

// // ========================== auth route component
export const AuthRoute = (props) => {
  const { children, redirect, path, type, auth, ...rest } = props;

  return (
    <Route
      {...rest}
      render={({ location }) => {
        const from = location.state ? location.state.from : null;
        if (!auth.token) return children;
        // Wait for profile hydrate so dealers are not sent to the client home.
        if (!isDealerUser(auth) && !isClientUser(auth)) return children;
        return (
          <Redirect to={redirectTarget(from, redirect || DEFAULT_ROUTE, auth)} />
        );
      }}
    />
  );
};

// private route component

export const PrivateRoute = (props) => {
  const { children, redirect, path, type, auth, ...rest } = props;
  return (
    <Route
      path={path}
      {...rest}
      render={({ location }) => {
        if (auth.token) return children;
        if (isRestoringSession()) return null;
        return (
          <Redirect
            to={{
              pathname: redirect ? redirect : DEFAULT_AUTH_ROUTE,
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};
// public route component

export const PublicRoute = (props) => {
  const { children, redirect, path, type, bool } = props;
  let redirectCondition = bool || false;
  return (
    <Route
      path={path}
      //   {...rest}
      render={({ location }) =>
        !redirectCondition ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: redirect ? redirect : DEFAULT_ROUTE,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};
